import { DynamicLoad } from '@/_cactus_core/build/dynamicLoad';





import a3134b673752c12e14d21dc5873e794c5b from "./generated-83f8d55d-aae9-4f37-92dc-031ae36740eb.json";

import abc972f442b0311005b1eef80a06bbc36b from "./generated-5fe9fdc8-964c-4c68-af1f-1dacaf665bb8.json";

import a6883552eca5828e863bc9f66f3b08df9b from "./generated-027faf7f-b0ad-4636-9fa5-3dce4517731f.json";

import abc624a28e02d499c5613ff27b741c4f4b from "./generated-194253cd-eb9e-4ce7-912c-8fe9996aca29.json";

import af9afce6d52d368a9a8e087750af4bdf9b from "./generated-235aa1bd-04d5-436c-9e0d-47832857fbfc.json";

import a63a2f1dc0e9126b619b82a8de26ce127b from "./generated-828e4120-50ed-48dc-9a26-3524aa819f55.json";

import a10c0c944944e01c387aa2ca9f151a4b2b from "./generated-9c40a977-4a6e-4e62-aa9e-a6856945a9a0.json";

import adcd2cdb60c45916d8e4997f7cd2a78bfb from "./generated-9526541e-7b67-4cb5-b366-072a27ec504d.json";

import ad9f79c69de23381f9f34dfd75b97249eb from "./generated-8c163c2b-37cd-4b2b-a228-60dce57f56be.json";

import ac0cdc024ad2539a6f78e466a16781541b from "./generated-74658b18-d090-4682-95fc-b6fbd6d6754c.json";

import a22e8b8c7c419f981c8360906f755b15bb from "./generated-1c986bc4-ebac-4b69-a4de-bc3ec76496bb.json";

import a5f7411d8a3aa786e87b02590b73c03abb from "./generated-df66c97f-1025-4b41-87f0-3af2e87d765b.json";

import a4203fc50ae60f1637f93d663f34c310db from "./generated-6ca87840-1b8e-432e-9539-183c382bdb8e.json";

import ad0855edb87c90de695679ee5cbf8c4c8b from "./generated-86246ace-4703-44a7-bace-6fd0d176b785.json";

import a284ad3a886702da2cc4d7f91b63a3ac3b from "./generated-2ed3ca13-474e-46e1-bb77-405714cc9082.json";

import a1b8f368fb089917de3988134babd111bb from "./generated-2bcf90e1-e003-4e94-b3c1-38650f6b0a0e.json";

import a59f8108075898381c09c10bd6836c487b from "./generated-3a0d531f-f1e5-4978-967a-d4fde51f6a32.json";





/* eslint-disable */

export default async function(url) {
  let storeData = false;

  async function direct(jsonResult) {
    return new Promise(async function(done,err) {
      try {
        storeData = {
          headers: jsonResult.headers,
          data: jsonResult.data,
        };
        
        done(storeData);
      } catch(e) {
        err(e);
      }
    });
  }

  async function ok(cachedJson) {
    return new Promise(async function(done,err) {
      try {
        const jsonResult = await DynamicLoad(cachedJson);

        storeData = {
          headers: jsonResult.headers,
          data: jsonResult.data,
        };

        done(storeData);
      } catch(e) {
        err(e);
      }
    });
  }
  
  try {
  
  




         if(url === "/api/appearance"){
            
                    await direct(a3134b673752c12e14d21dc5873e794c5b);
                
        }
    


        else if(url === "/api/getlegalterm"){
            
                    await direct(abc972f442b0311005b1eef80a06bbc36b);
                
        }
    


        else if(url === "/api/country"){
            
                    await direct(a6883552eca5828e863bc9f66f3b08df9b);
                
        }
    


        else if(url === "/api/crypto/all"){
            
                    await direct(abc624a28e02d499c5613ff27b741c4f4b);
                
        }
    


        else if(url === "/api/bff/features"){
            
                    await direct(af9afce6d52d368a9a8e087750af4bdf9b);
                
        }
    


        else if(url === "/api/payment-providers"){
            
                    await direct(a63a2f1dc0e9126b619b82a8de26ce127b);
                
        }
    


        else if(url === "/api/bff/games/top-wins"){
            
                    await direct(a10c0c944944e01c387aa2ca9f151a4b2b);
                
        }
    


        else if(url === "/api/bff/games/last-wins"){
            
                    await direct(adcd2cdb60c45916d8e4997f7cd2a78bfb);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-da-pg&per_page=15"){
            
                    await direct(ad9f79c69de23381f9f34dfd75b97249eb);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=roleta&per_page=16"){
            
                    await direct(ac0cdc024ad2539a6f78e466a16781541b);
                
        }
    


        else if(url === "/api/undefined&per_page=undefined"){
            
                    await direct(a22e8b8c7c419f981c8360906f755b15bb);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-crash&per_page=15"){
            
                    await direct(a5f7411d8a3aa786e87b02590b73c03abb);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-de-aventura&per_page=15"){
            
                    await direct(ad9f79c69de23381f9f34dfd75b97249eb);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=cassino-ao-vivo&per_page=15"){
            
                    await direct(a4203fc50ae60f1637f93d663f34c310db);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=slots&per_page=15"){
            
                    await direct(ad0855edb87c90de695679ee5cbf8c4c8b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-novos&per_page=15"){
            
                    await direct(ad9f79c69de23381f9f34dfd75b97249eb);
                
        }
    


        else if(url === "/api/casino-games/filter?per_page=1&per_page=15"){
            
                    await direct(a284ad3a886702da2cc4d7f91b63a3ac3b);
                
        }
    


        else if(url === "/api/casino-games/filter?providers[]=hacksaw&per_page=15"){
            
                    await direct(a1b8f368fb089917de3988134babd111bb);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=blackjack&per_page=15"){
            
                    await direct(a59f8108075898381c09c10bd6836c487b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories%5B%5D=all"){
            
                    await direct(a284ad3a886702da2cc4d7f91b63a3ac3b);
                
        }
    





  } catch(ex){
    console.log('failed to get cache',ex,url);
  }

  return storeData;
};

/* eslint-enable */